// extracted by mini-css-extract-plugin
export default {"options-cell":"OptionsTableHeadCell_options-cell__tUToF","actions__wrapper":"OptionsTableHeadCell_actions__wrapper__I1O78"};